<template>
  <v-dialog
    v-model="open"
    max-width="520"
    :retain-focus="false"
  >
    <v-card class="pa-5">
      <v-card-title class="text-h5 mb-4 pa-0">
        {{ title }}
      </v-card-title>
      <v-card-text class="pa-0">
        <p>{{ message }}</p>
        <template v-if="kind !== 'error'">
          <p v-if="kind === 'ai'">
            {{ $t("\n            AI Text uses 1 credit. Image restoration uses 5 credits. Add 100 credits for $5, or upgrade for a larger monthly allowance.\n          ") }}
          </p>
          <p v-else>
            {{ $t("\n            Upgrade for more space, or permanently delete media from your gallery. Your existing files remain available.\n          ") }}
          </p>
          <p class="text-body-2">
            {{ $t("\n            Billing opens in a new tab so you can keep this page open, then retry when your balance updates.\n          ") }}
          </p>
          <v-btn
            color="primary"
            href="/billing"
            target="_blank"
            rel="noopener"
            class="mb-3"
          >
            {{ kind === 'ai' ? $t("Add credits or upgrade") : $t("View upgrade options") }}
          </v-btn>
        </template>
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-btn
          text
          @click="open = false"
        >
          {{ kind === 'error' ? $t("Close") : $t("Back to my work") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { t } from '@/i18n'

export default {
  data: () => ({ open: false, kind: '', message: '' }),
  computed: { title() { return ({ storage: 'More storage needed', ai: 'More AI credits needed' })[this.kind] || t('Unable to complete this action') } },
  mounted() { window.addEventListener('resources:notice', this.show) },
  beforeDestroy() { window.removeEventListener('resources:notice', this.show) },
  methods: { show(event) { this.kind = event.detail.kind; this.message = event.detail.message; this.open = true } },
}
</script>
